module.exports = __webpack_public_path__ + "static/gallery15-d9d229b18e0dbb875a39b2a3ee5279d6.png";